import React, { useState } from"react";
import {
 Box,
 Button,
 Grid,
 TextField,
 Typography,
 IconButton,
 InputAdornment,
 Alert,
} from"@mui/material";
import Visibility from"@mui/icons-material/Visibility";
import VisibilityOff from"@mui/icons-material/VisibilityOff";
import axios from"axios";
import { useParams, useNavigate } from"react-router-dom";
import API_BASE_URL from"../Config/config";

const ResetPassword = () => {
 const { token } = useParams(); // expects param called"token"
 const navigate = useNavigate();

 const [newPassword, setNewPassword] = useState("");
 const [confirmPassword, setConfirmPassword] = useState("");
 const [showNewPassword, setShowNewPassword] = useState(false);
 const [showConfirmPassword, setShowConfirmPassword] = useState(false);
 const [loading, setLoading] = useState(false);
 const [message, setMessage] = useState("");
 const [error, setError] = useState("");

 const handleResetPassword = async (e) => {
 e.preventDefault();
 setLoading(true);
 setMessage("");
 setError("");

 if (newPassword !== confirmPassword) {
 setError("Passwords do not match!");
 setLoading(false);
 return;
 }

 try {
 const response = await axios.put(
 `${API_BASE_URL}/user/reset-password/${token}`,
 { newPassword }
 );

 if (response.status === 200) {
 setMessage("Password reset successfully. Redirecting to login...");
 setTimeout(() => navigate("/login"), 2000);
 } else {
 setError("Something went wrong. Please try again.");
 }
 } catch (err) {
 console.error(err);
 setError("Invalid or expired reset link.");
 } finally {
 setLoading(false);
 }
 };

 return (
 <Grid
 container
 justifyContent="center"
 alignItems="center"
      sx={{
        minHeight: "100vh",
        backgroundColor: "var(--bg-main)",
        py: 4,
      }}
    >
      <Grid item xs={12} sm={10} md={6} lg={4}>
        <Box
          sx={{
            borderRadius: 4,
            boxShadow: "0 20px 50px rgba(31, 138, 203, 0.15)",
            overflow: "hidden",
            backgroundColor: "var(--bg-card)",
            color: "var(--text-body)",
            px: 4,
            py: 5,
            border: "1px solid var(--accent-gray)",
          }}
        >
          <Typography
            variant="h4"
            align="center"
            sx={{ fontWeight: 900, color: "var(--text-heading)", mb: 2, letterSpacing: "-0.02em" }}
          >
 Reset Password
 </Typography>

          <Typography align="center" sx={{ color: "var(--text-muted)", mb: 4, fontWeight: 500 }}>
            Set a new password for your account.
          </Typography>

          {message && <Alert severity="success" sx={{ mb: 3, borderRadius: "12px" }}>{message}</Alert>}
          {error && <Alert severity="error" sx={{ mb: 3, borderRadius: "12px" }}>{error}</Alert>}

          <form onSubmit={handleResetPassword}>
            <TextField
              label="New Password"
              type={showNewPassword ? "text" : "password"}
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              fullWidth
              required
              InputProps={{
                sx: { backgroundColor: "var(--bg-main)", color: "var(--text-heading)", fontWeight: 600, borderRadius: "12px" },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowNewPassword(!showNewPassword)} edge="end" sx={{ color: "var(--text-muted)" }}>
                      {showNewPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ sx: { color: "var(--text-muted)", fontWeight: 600 } }}
              sx={{ 
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "var(--accent-gray)" },
                  "&:hover fieldset": { borderColor: "var(--primary-blue)" },
                  "&.Mui-focused fieldset": { borderColor: "var(--primary-blue)" },
                }
              }}
            />

            <TextField
              label="Confirm Password"
              type={showConfirmPassword ? "text" : "password"}
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              fullWidth
              required
              InputProps={{
                sx: { backgroundColor: "var(--bg-main)", color: "var(--text-heading)", fontWeight: 600, borderRadius: "12px" },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end" sx={{ color: "var(--text-muted)" }}>
                      {showConfirmPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              InputLabelProps={{ sx: { color: "var(--text-muted)", fontWeight: 600 } }}
              sx={{ 
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  "& fieldset": { borderColor: "var(--accent-gray)" },
                  "&:hover fieldset": { borderColor: "var(--primary-blue)" },
                  "&.Mui-focused fieldset": { borderColor: "var(--primary-blue)" },
                }
              }}
            />

            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading}
              sx={{
                backgroundColor: "var(--primary-blue)",
                color: "#fff",
                fontWeight: 800,
                py: 2,
                borderRadius: "12px",
                textTransform: "none",
                fontSize: "1.1rem",
                boxShadow: "0 10px 20px rgba(43, 176, 230, 0.3)",
                "&:hover": {
                  backgroundColor: "var(--secondary-blue)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 12px 25px rgba(31, 138, 203, 0.4)",
                },
                transition: "all 0.2s"
              }}
            >
              {loading ? "Resetting..." : "Reset Password"}
            </Button>
          </form>
 </Box>
 </Grid>
 </Grid>
 );
};

export default ResetPassword;



